import { render, staticRenderFns } from "./SeverityTextFieldSelector.vue?vue&type=template&id=c717d1d6&scoped=true&"
import script from "./SeverityTextFieldSelector.vue?vue&type=script&lang=ts&"
export * from "./SeverityTextFieldSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SeverityTextFieldSelector.vue?vue&type=style&index=0&id=c717d1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c717d1d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
